/* eslint-disable import/prefer-default-export */
/**
 * * Promisified listener
 * @param {keyof WindowEventMap | keyof HTMLElementEventMap} eventName
 * @param {Window | HTMLElement} [target=window]
 * @param {Window} [$window=window] - window object for unit tests
 *
 * @description
 * This function returns a promise which resolves when the event is triggered.
 *
 * @example
 * ```ts
 * const element = document.getElementById('element');
 * promisifiedListener('click', element).then(() => console.log('clicked'));
 *
 * ```
 */
export const promisifiedDOMListener = (eventName, target = window, $window = window) => new Promise((resolve) => {
  /**
   * @param {Event} e
   */
  const listener = (e) => {
    target.removeEventListener(eventName, listener);
    resolve(e);
  };
  target.addEventListener(eventName, listener);
  /**
   * All the listeners should be removed when the page is hidden
   * to prevent memory leaks and unexpected behavior.
   *
   * For example, if the user navigates back to the previous page,
   * promise could be not resolved and the listener could be still active
   * for SPA cases (Not Available page and etc.)
   */
  $window.addEventListener('pagehide', listener);
});
